import { render, staticRenderFns } from "./posted.vue?vue&type=template&id=5d4960ed&scoped=true"
import script from "./posted.vue?vue&type=script&lang=js"
export * from "./posted.vue?vue&type=script&lang=js"
import style0 from "./posted.vue?vue&type=style&index=0&id=5d4960ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4960ed",
  null
  
)

export default component.exports